import { Pipe } from '@angular/core';

@Pipe({
  name: 'dateToJalali',
  standalone: false,
})
export class DateToJalaliPipe {
  transform(date: Date | string, options?: Intl.DateTimeFormatOptions): string {
    if (!date) return '';

    const defaultOptions: Intl.DateTimeFormatOptions = {
      hour: '2-digit',
      minute: '2-digit',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    };

    const formatOptions = options ?? defaultOptions;
    const jalaliDateFormatter = new Intl.DateTimeFormat(
      'fa-IR-u-ca-persian',
      formatOptions,
    );

    const dateObj = typeof date === 'string' ? new Date(date) : date;
    // return in this format yyyy/MM/dd HH:mm

    const formattedDate = jalaliDateFormatter.format(dateObj);
    return formattedDate.replace(/\//g, '/').replace(/,/g, ' -').trim();
  }
}
